import * as actionTypes from "../actions/actionTypes";
const initialState = {
  settings: null,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case actionTypes.SAVE_REMOTE_SITE_SETTINGS:

      return {
        ...state,
        settings: {...action.settings, masterIsLoading: false},
      };


    case actionTypes.SAVE_LOCAL_SITE_SETTINGS:

      // hold objects such as lastPrivateUrl, activeLanguageObject
      
      return {
        ...state,
        parameters: {...state.parameters, ...action.data},
      };


    default:
      return  state;
  }
};
